define([], () => {
    function daysInMonth(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }
    
    function getAgeInYears(localDate){
                
        var birthDate = new Date(localDate.year, localDate.month, localDate.day);
        var birthYear = birthDate.getFullYear();
        var birthMonth = birthDate.getMonth();
        var birthDay = birthDate.getDate();
        
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var currentMonth = currentDate.getMonth();
        var currentDay = currentDate.getDate();
        
        var age = currentYear - birthYear;
        var ageMonth = currentMonth - birthMonth;
        var ageDay = currentDay - birthDay;
        
        if (ageMonth < 0 || (ageMonth == 0 && ageDay < 0)) {
            age = parseInt(age) - 1;
        }
        
        return age;
    }

    
    function isValidAge(localDate, ageLimit){
        
        //var ageLimit = 18;
        if(!localDate){
            return true;
        }
        var age = getAgeInYears(localDate);
        
        //console.log("Birth Date: ",birthYear,birthMonth,birthDay);
        //console.log("Current Date: ", currentYear, currentMonth, currentDay);       
        
        if(age < ageLimit){
            //console.log("Not a valid age: ", age, ageMonth, ageDay); 
            return false;
        }
        
        //console.log("Valid Age: ", age, ageMonth, ageDay); 
        
        return true;
    }
    
    // To validate age first licensed in US in Add drivers screen
    function isLicensedAgeValid(inputAge, dateOfBirth, minAge) {
        if(!dateOfBirth){
            return true;
        }
        //console.log("Min Age:: ",minAge, inputAge);
        
        var currentAge = getAgeInYears(dateOfBirth);
        
        return (inputAge <= currentAge && inputAge >= minAge) ? true : false;
    }

    return {
        daysInMonth: daysInMonth,
        daysInLocalDate: ld => ld ? daysInMonth(ld.year, ld.month) : null,
        toMidnightDate: localDate => localDate ? new Date(localDate.year, localDate.month, localDate.day) : null,
        toMidnightCustomDate: localDate => localDate ? new Date(localDate.year, localDate.month, localDate.day) : null,
        isValidAge: (localDate,ageLimit) => isValidAge(localDate, ageLimit),
        isValidLicenseAge: (localDate) => isValidAge(localDate, 16),
        isLicensedAgeValid: (inputAge,dateOfBirth,minAge) => isLicensedAgeValid(inputAge, dateOfBirth, minAge)
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/util/LocalDateUtil.js
 **/